import React from 'react';
import classNames from 'classnames';
import { Skeleton } from '../layout/loading';

export default function TextButton({
  children,
  disabled = false,
  loading = false,
  className = '',
  ...props
}) {
  if (loading) {
    return (
      <Skeleton
        className={classNames(
          'h-6',
          !className.includes('w-') && 'w-16',
          className
        )}
      />
    );
  }

  return (
    <button
      type="button"
      disabled={disabled}
      className={classNames(
        'font-semibold text-indigo-400 hover:text-indigo-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 rounded-sm cursor-pointer',
        { 'opacity-50 cursor-not-allowed': disabled },
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
